'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CancelCta = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

var _BaseCta = require('./BaseCta');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CancelCta = exports.CancelCta = function CancelCta(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    _BaseCta.BaseCta,
    {
      className: (0, _classnames2.default)(className, 'bt--tertiary'),
      onClick: onClick
    },
    _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'schedule.cta.cancel',
      defaultMessage: 'Cancel'
    })
  );
};

CancelCta.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired
};